import '../App.css';
import { Link } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import Logo from '../images/logo.png'
import Cart from '../images/cart.png';
export default function Navbar() {

    const { user, logOut } = UserAuth();
    const { googleSignIn } = UserAuth();
    const handleSignOut = async () => {
        try {
            await logOut();
        }
        catch (e) {
            console.log(e)
        }
    }
    const handleSignIn = async () => {
        try {
            await googleSignIn();
        }
        catch (e) {
            console.log(e)
        }
    }
    

    return (
        <>
            <nav>
                <Link className='nav-link' to='/'>
                <img className='logo-img' src={Logo} alt='logo'/>
                </Link>
                <span>
                    {(user) ? (
                        <button onClick={handleSignOut}>Log Out
                            {
                            (user.photoURL) ?
                            <img className='profile-img' src={user.photoURL} alt='' />
                            : null
                            }
                        </button>
                    ) : (
                        <button onClick={handleSignIn}>Log In</button>
                    )}
                    <Link className='nav-link' to='/cart'>
                        <img className='cart-img' src={Cart} alt='cart' />
                    </Link>
                </span>
            </nav>
        </>
    )

}
